var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKpi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 12,
    viewBox: "0 0 17 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.4545 0C14.601 0 13.9091 0.671539 13.9091 1.5C13.9091 1.70929 13.9542 1.90787 14.034 2.08887L10.9862 6.03287C10.9284 6.02646 10.8778 6 10.8182 6C10.5742 6 10.3513 6.06619 10.1461 6.16397L7.70916 4.58716C7.71105 4.55667 7.72727 4.53094 7.72727 4.5C7.72727 3.67154 7.03538 3 6.18182 3C5.32825 3 4.63636 3.67154 4.63636 4.5C4.63636 4.7092 4.68145 4.90787 4.76116 5.08878L1.71355 9.03296C1.65572 9.02655 1.60507 9 1.54545 9C0.691889 9 0 9.67154 0 10.5C0 11.3284 0.691889 12 1.54545 12C2.39902 12 3.09091 11.3284 3.09091 10.5C3.09091 10.2907 3.04573 10.0921 2.96602 9.91113L6.01392 5.96704C6.07174 5.97345 6.1222 6 6.18182 6C6.42584 6 6.64874 5.93372 6.8539 5.83594L9.29084 7.41284C9.28895 7.44333 9.27273 7.46906 9.27273 7.5C9.27273 8.32837 9.96462 9 10.8182 9C11.6717 9 12.3636 8.32837 12.3636 7.5C12.3636 7.2908 12.3185 7.09222 12.2388 6.91122L15.2865 2.96704C15.3443 2.97345 15.3949 3 15.4545 3C16.3081 3 17 2.32837 17 1.5C17 0.671539 16.3081 0 15.4545 0Z",
    strokeWidth: 0,
    fill: "#393939"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKpi);
export default __webpack_public_path__ + "static/media/kpi.50009ccfb82124fb8e1d7943fa165b94.svg";
export { ForwardRef as ReactComponent };